import { render, staticRenderFns } from "./LiteButton.vue?vue&type=template&id=785dcd10&scoped=true&"
import script from "./LiteButton.vue?vue&type=script&lang=js&"
export * from "./LiteButton.vue?vue&type=script&lang=js&"
import style0 from "./LiteButton.vue?vue&type=style&index=0&id=785dcd10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785dcd10",
  null
  
)

export default component.exports